import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import { Table, Card, Row, Spin, Col, Button, Tooltip as TooltipAnd, Modal,Input  } from 'antd';
import { errorMessage } from "../Helpers/Util";
import { DATE_TIME_FORMAT } from "../../constants";
import { DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import * as util from "../Helpers/Util";

import getBasvuruHistory from "../../services/getBasvuruHistory";
import deleteLastEvent from "../../services/deleteLastEvent";
import basvuruSilinenIslemKaydiniGetir from "../../services/basvuruSilinenIslemKaydiniGetir";

const { TextArea } = Input;

const parsed = queryString.parse(history.location.search);
const { confirm } = Modal;
const modalTitleStyle = {
  fontWeight: 'bold',
  fontSize: '16px'
};
const modalContentStyle = {
  fontSize: '16px'
};
const modalContentBoldStyle = {
  fontWeight: 'bold',
  color: 'red'
};
const BasvuruEventSilForm = () => {
  const [spining, setSpining] = useState(false);
  const [basvuruHistory, setBasvuruHistory] = useState([]);
  const [silinenIslemHistory, setSilinenIslemHistory] = useState([]);
  const basvuruId = parseInt(parsed.basvuruId);


  const load = async () => {
    setSpining(true);
    let basvuruHistoryRequest = {};
    basvuruHistoryRequest.basvuruId = basvuruId;
    await getBasvuruHistory(basvuruHistoryRequest).then(res => {
      if (res.data.success) {
        setBasvuruHistory(res.data.result);
      } else {
        errorMessage(res.data.message)
      }
    }).catch(err => {
      errorMessage(err.message)
    });

    await basvuruSilinenIslemKaydiniGetir(basvuruId).then(res => {
      if (res.data.success) {
        setSilinenIslemHistory(res.data.result);
      }
    }).catch(err => {
      errorMessage(err.message)
    });

    setSpining(false);
  }
  useEffect(() => {
    load()
  }, []);


  const deleteEvent = async (data) => {
    await deleteLastEvent(data).then(resp => {
      if (!resp.data.success) {
        util.errorMessage(resp.data.message);
      } else {
        util.successMessage(resp.data.message);
      }
    }).catch(ex => {
      util.errorMessage(String(ex.message));
    });
  }



  const openConfirm = (record) => {
    confirm({
      title: <div><span style={modalTitleStyle}>Emin Misiniz?</span></div>,
      content:
        <div style={modalContentStyle}>
          Bu işlemi yaptığınızda başvurunun durumu{' '}
          <span style={modalContentBoldStyle}> {record.fromStateName} </span>olarak güncellenecektir.
          <br/><br/>
          Açıklama <span style={modalContentBoldStyle} >*</span> 
          <TextArea id="deleteDescription"  placeholder="Açıklama"  />
          <br/>
          <span id="deleteDescriptionErr" style={modalContentBoldStyle}></span>
        </div>,

      onOk: async () => {
        try {
          let deleteDescription = document.getElementById("deleteDescription").value;

          if(util.isNullOrEmptyOrUndefined(deleteDescription)){
            document.getElementById("deleteDescriptionErr").innerHTML = "Lütfen açıklama giriniz !";
            return Promise.reject("Açıklama Giriniz");
          }
          else{
            setSpining(true);
            let deleteLastEventRequest = {};
            deleteLastEventRequest.basvuruId = parsed.basvuruId;
            deleteLastEventRequest.targetStateId = record.fromStateId;
            deleteLastEventRequest.deleteDescription = deleteDescription;
            await deleteEvent(deleteLastEventRequest);
            setSpining(false);
            window.location.reload();
            return Promise.resolve();
          }
        } catch (e) {
          return console.log('Bir hata oluştu!');
        }
      },
      onCancel() { 
        
      },
    });
  }
  const columns = [
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
      hidden: true
    },
    {
      title: 'Id',
      dataIndex: 'basvuruId',
      key: 'basvuruId',
      hidden: true
    },
    {
      title: 'İşlem',
      key: 'delete',
      dataIndex: 'delete',
      render: (text, record, index) => {
        if (index == 0 && record.eventDetailId != 0) {
          return <Button type="primary" danger
            onClick={() => openConfirm(record)}
            icon={<DeleteOutlined />}>İşlemi Sil</Button>;
        }
      }
    },
    {
      title: 'Tarih',
      dataIndex: 'eventDate',
      key: 'eventDate',
      render: (value) => value && <div>{moment(value).format(DATE_TIME_FORMAT)}</div>
    },
    {
      title: 'eventDetailId',
      dataIndex: 'eventDetailId',
      key: 'eventDetailId',
      hidden: true
    },
    {
      title: 'Olay',
      dataIndex: 'eventDesc',
      key: 'eventDesc',
    },
    {
      title: 'fromStateId',
      dataIndex: 'fromStateId',
      key: 'fromStateId',
      hidden: true
    },
    {
      title: 'fromStateName',
      dataIndex: 'fromStateName',
      key: 'fromStateName',
      hidden: true
    },
    {
      title: 'Durum',
      dataIndex: 'toStateName',
      key: 'toStateName',
    },
    {
      title: 'İşlemi Yapan Kullanıcı',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Açıklama',
      dataIndex: 'description',
      key: 'description',
    }
  ].filter(item => !item.hidden);


  const silinenColumns = [
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
      hidden: true
    },
    {
      title: 'İşlemi Yapan Kullanıcı',
      dataIndex: 'kullanici',
      key: 'kullanici'
    },
    {
      title: 'Geri Alınan İşlem',
      dataIndex: 'eventAdi',
      key: 'eventAdi'
    },
    {
      title: 'Tarih',
      dataIndex: 'tarih',
      key: 'tarih',
      render: (value) => value && <div>{moment(value).format(DATE_TIME_FORMAT)}</div>
    },
    {
      title: 'Silinme Nedeni',
      dataIndex: 'deleteDescription',
      key: 'deleteDescription'
    },
    
  ].filter(item => !item.hidden);

  const dataSource = basvuruHistory.map((result) => {
    return {
      key: result.eventDetail.objectid + "-" + result.eventDate,
      eventsId: result.objectid,
      eventDate: result.eventDate,
      eventDetailId: result.eventDetail.objectid,
      eventDesc: result.eventDetail.adi,
      fromStateId: result.currentState.objectid,
      fromStateName: result.currentState.adi,
      toStateName: result.afterState.adi,
      username: result.islemiYapanKullanici.adi + " " + result.islemiYapanKullanici.soyadi,
      description: result.description,

    };
  });

  
  const dataSilinenSource = silinenIslemHistory.map((result) => {
    return {
      key: result.ConnectorId,
      kullanici: result.Kullanici != null ? result.Kullanici.adi + " " + result.Kullanici.soyadi : '',
      eventAdi: result.Event != null ? result.Event.description : '',
      tarih : result.cDate,
      deleteDescription : result.DeleteDescription
    };
  });

  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} >
    <Card
      style={{ margin: "20px" }}
      title={<h4 style={{ fontWeight: "bolder", color: "white" }}>Başvuruyu Geri Al</h4>}
      className="ant-card-head-title-large">
      <Row gutter={16}>
        <Col span={24}>
          {basvuruHistory.length > 0 &&
            <Table scroll={{}} pagination={false} bordered dataSource={dataSource}
              columns={columns}
              rowKey={"key"}
              title={() => <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3 style={{ fontWeight: "bolder" }}> {basvuruId} No'lu Başvuru Süreç Geçmişi</h3>
              </div>}
            />
          }
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          {silinenIslemHistory.length > 0 &&
            <Table scroll={{}} pagination={false} bordered dataSource={dataSilinenSource}
              columns={silinenColumns}
              rowKey={"key"}
              title={() => <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3 style={{ fontWeight: "bolder" }}> {basvuruId} Başvuru Geri Alma İşlem Geçmişi</h3>
              </div>}
            />
          }
        </Col>
      </Row>


    </Card>
  </Spin>
}
export default BasvuruEventSilForm;